import { SummaryStepRowProps } from './SummaryStepRow.types';
import { Box, PressableIcon, Text } from '@betty/moonlight';
import React, { memo } from 'react';

function SummaryStepRow({
  value,
  onPress,
  locKey,
  locNS,
}: SummaryStepRowProps) {
  return (
    <Box
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      paddingVertical="space-500"
      borderBottomWidth="border-width-025"
      borderBottomColor="neutral-300"
    >
      <Text
        variant="body-s"
        locKey={locKey}
        locNS={locNS}
        color="darkSurfaceSecondary"
        flex={1}
      />
      <Text
        variant="body-s"
        flex={2}
        textAlign="left"
        color="darkSurfacePrimary"
      >
        {value}
      </Text>
      <PressableIcon
        name="edit"
        width="space-600"
        height="space-600"
        gradient="accentBackground"
        onPress={onPress}
      />
    </Box>
  );
}

export default memo(SummaryStepRow);
